<svelte:head>
    <link rel='stylesheet' href='/global.css'>
    <link rel="stylesheet" type="text/css" href="css/charts.css" />
</svelte:head>

<script>

    import Filter from "./utils/filter.svelte"
    import Header from "./header.svelte"
    import dayjs from "dayjs";

    import {
        platformIdentifiers,
        loadSpecialOrFilteredChartData,
        chartOptions
    } from "../utils/charts"

    import {
        isDatesDefault,
        isFilterDefault
    } from "./utils/filter";

    import {
        getReviews
    } from "./api.svelte"

    import { onMount } from "svelte";
    import { getContext } from "svelte";

    import {
        checkUnauthorized,
        getLocalPropertyId
    } from "../utils/session";

    const router = getContext('router');

    let showSubReview = false;
    let currentReview;
    let reviewData;

    let filterData = JSON.parse(JSON.stringify(chartOptions));
    let earliest;

    let data;

    let propertyId = getLocalPropertyId();

    onMount(() => {

        getData();
    });

    let getData = (filtered = false) => {

        let chartId = 'table';
        let chartType = 'chart';

        let propertyId = getLocalPropertyId();

        if (filtered) {

            if (filterData['dates']['start'] === 0) {

                filterData['dates']['start'] = earliest;
            }

            loadSpecialOrFilteredChartData(router, false, chartId, chartType, propertyId, filterData).then((result) => {

                data['data'] = result['data'];
                reviewData = JSON.parse(JSON.stringify(data['data']));

            });

            return;
        }

        getReviews(propertyId).then((result) => {

            if (result['status'] !== 'success') {

                if (checkUnauthorized(router, result)) {

                    return;
                }

                console.log(result);

                return;

            }

            if (!earliest) {

                earliest = result['chart']['settings']['meta']['earliest'];
            }

            data = result['chart'];
            reviewData = JSON.parse(JSON.stringify(data['data']));

        });

    };

    let getStars = (rating) => {

        let stars = [];

        for (let r = 1; r <= 5; r++) {

            stars.push(
                `<img style="width: 1.78vh; margin-right: 0.46vh" src="images/icon-table-${(r <= rating) ? 'star-filled' : 'star'}.svg" />`
            );

        }

        return stars.join('');

    };

    let handleKeywordSearch = (query) => {

        let searchValue = query.detail['keyword'];
        let type = query.detail['type'];

        if (type === 'reset' || searchValue === "") {

            reviewData = data['data'];
            return;
        }

        let formattedQuery = searchValue.toLowerCase().split(' ');

        let updateData = [];

        data['data'].forEach((keyItem) => {

            for (const queryItem of formattedQuery) {

                if ((keyItem['title'].toLowerCase().includes(queryItem)) || (keyItem['content'].toLowerCase().includes(queryItem))) {

                    updateData.push(keyItem);
                }
            }
        });

        reviewData = updateData;
    };

    let receiveChartOptions = (data) => {

        filterData['filter'] = data.detail['map']['filter'];

        let filtered;

        if (!isFilterDefault(filterData['filter'])) {

            filtered = true;
        }

        getData(filtered);

    };

    let receiveDateOptions = (data) => {

        filterData['dates'] = data.detail;

        let filtered;

        if (!isDatesDefault(filterData['dates'], earliest)) {

            filtered = true;
        }

        getData(filtered);

    }

    let triggerModal = (review) => {

        currentReview = review;

        showSubReview = !showSubReview;

    };


</script>

<Header
        showSearch={true}
        allowDropdown={false}
        startDate={earliest}
        keyword=""
        on:keywordsearch={handleKeywordSearch}
        on:searchevent={handleKeywordSearch}
        on:dates={receiveDateOptions}
        on:propertychange={() => getData()}
/>
{#if data}

    <Filter
            data={data}
            on:filtersMenu={receiveChartOptions}
    />

    <section>

        <div class="main">

            <div id="chart-stats">

                <div class="stats-item">

                    <img class="stats-icon" src="images/icon-stats-reviews.svg" />

                    <div class="stats-meta">

                        <div class="stats-title">Bewertungen</div>
                        <div class="stats-num">{reviewData.length}</div>

                    </div>

                </div>

            </div>

            <div id="chart-container">

                <h1 class="chart-title">Übersicht</h1>

                {#if reviewData.length === 0}

                    <div id="nodata" class="show">Keine Daten verfügbar.</div>

                {:else}

                    <div id="reviews-container">

                        {#each reviewData as review}

                            <div class="review-item" data-rid={review['id']} on:click|stopPropagation={() => triggerModal(review)}>

                                <div class="review-meta">
                                    <div class="meta-stars">
                                        <div class="meta-stars-count">{review['rating']}</div>
                                        <div class="meta-stars-items">{@html getStars(review['rating'])}</div>
                                    </div>
                                    <div class="meta-date">{dayjs(review['created'] * 1000).locale('de').format('D. MMMM YYYY')}</div>
                                </div>

                                <div class="review">
                                    {#if review['title'] !== ''}
                                        <div class="review-title">{review['title']}</div>
                                    {/if}
                                    <div class="review-content">{review['content']}</div>
                                </div>

                                <div class="review-meta">
                                    <div class="meta-platform">{platformIdentifiers[review['platform']]}</div>
                                    <div class="meta-reviewer">{review['reviewer']}</div>
                                </div>
                            </div>

                        {/each}

                    </div>

                {/if}




            </div>
        </div>
    </section>

{/if}




{#if showSubReview}

    <div class="whatever" on:click={() => showSubReview = false}>
        <div class="chart-info" class:show={showSubReview}>

            <div class="close">
                <img src="images/icon-close.svg" alt="Close" on:click|stopPropagation={() => showSubReview = !showSubReview}>
            </div>

            <div class="review-item" data-rid={currentReview['id']}>

                <div class="review-meta">
                    <div class="meta-stars">
                        <div class="meta-stars-count">{currentReview['rating']}</div>
                        <div class="meta-stars-items">{@html getStars(currentReview['rating'])}</div>
                    </div>
                    <div class="meta-date">{dayjs(currentReview['created'] * 1000).locale('de').format('D. MMMM YYYY')}</div>
                </div>

                <div class="review">
                    {#if currentReview['title'] !== ''}
                        <div class="review-title">{currentReview['title']}</div>
                    {/if}
                    <div class="review-content">{currentReview['content']}</div>
                </div>

                <div class="review-meta">
                    <div class="meta-platform">{platformIdentifiers[currentReview['platform']]}</div>
                    <div class="meta-reviewer">{currentReview['reviewer']}</div>
                </div>
            </div>

        </div>
    </div>

{/if}



<style>

    /*#reviews-container {*/
    /*    width: 88.89vh;*/
    /*    margin-top: 5.87vh;*/
    /*    max-height: 70vh;*/
    /*    overflow-y: scroll;*/
    /*    overflow-x: hidden;*/
    /*    padding-right: 0.5vh;*/
    /*}*/
    #reviews-container {
        width: 105vh;
        margin-top: 5.87vh;
        max-height: 70vh;
        overflow-y: scroll;
        overflow-x: hidden;
        padding-right: 0.5vh;
        display: grid;
        grid-template-columns: auto auto;
        grid-gap: 2.84vh;
    }

    #reviews-container .review-item {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        width: 100%;
        padding: 3.56vh;
        /*margin-bottom: 2.84vh;*/
        background-color: #FFFFFF;
        border-radius: 1.39vh;
        -webkit-box-shadow: 0px 5px 15px 0px rgba(73, 119, 172, 0.05);
        -moz-box-shadow: 0px 5px 15px 0px rgba(73, 119, 172, 0.05);
        box-shadow: 0px 5px 15px 0px rgba(73, 119, 172, 0.05);
        justify-content: space-between;
        cursor: pointer;
    }

    #reviews-container .review-item span.highlight {
        background-color: #c6c6c6;
    }

    #reviews-container .review-item.hide {
        display: none;
    }

    #reviews-container .review-item:last-child {
        margin-bottom: 0;
    }

    .review-item .review-meta {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-family: 'Raleway', sans-serif;
        font-size: 1.51vh;
    }

    .review-item .review-meta:first-child {
        padding-bottom: 2.13vh;
    }

    .review-item .meta-stars {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .review-item .meta-stars-count {
        padding-right: 0.64vh;
        font-family: 'Roboto', sans-serif;
        font-weight: 500;
        font-size: 1.78vh;
    }

    .review-item .meta-stars-items {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    /*.review-item .meta-stars-items img {*/
    /*    width: 1.78vh;*/
    /*    margin-right: 0.46vh;*/
    /*}*/

    .review-item .meta-date {
        font-family: 'Raleway', sans-serif;
        font-weight: 400;
        font-size: 1.78vh;
    }

    .review-item .review {
        display: flex;
        flex-direction: column;
        padding-bottom: 2.13vh;
        font-family: 'Raleway', sans-serif;
        font-size: 1.78vh;
    }

    .review-item .review-title {
        margin-bottom: 0.92vh;
        font-weight: 500;
    }

    .review-item .review-content {
        font-weight: 400;
        line-height: 1.5;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-word;
    }
    /*.review-item .review-content {*/
    /*    font-weight: 400;*/
    /*    line-height: 1.5;*/
    /*}*/

    .whatever {
        height: 100vh;
        position: absolute;
        width: 100%;
        top: 0;
        z-index: 9999;
    }

    .chart-info .review-item .review-content {
        display: block;
        max-height: 50vh;
        overflow: scroll;

    }

    .chart-info .review-item {
        margin-top: 2vh;
    }


</style>


